// src/services/legendService.ts
import { FISHING_LEGENDS, FishingLegend } from '../data/legends';

export class LegendService {
  /**
   * Detecta se um usuário é uma lenda baseado no email e nome completo
   */
  static async detectLegend(userData: {
    email: string;
    fullName: string;
  }): Promise<FishingLegend | null> {
    const email = userData.email.toLowerCase();
    const name = userData.fullName.toLowerCase();

    // 1. Busca por padrões de email
    for (const legend of FISHING_LEGENDS) {
      for (const pattern of legend.emailPatterns) {
        // Converte padrão de glob (*nakamura*) para RegExp
        const regexPattern = pattern.replace(/\*/g, '.*');
        if (new RegExp(`^${regexPattern}$`, 'i').test(email)) {
          return legend;
        }
      }
    }

    // 2. Busca por nome (fuzzy match)
    for (const legend of FISHING_LEGENDS) {
      const legendName = legend.fullName.toLowerCase();
      const legendNicknames = legend.nicknames.map(n => n.toLowerCase());

      // Verifica se o nome do usuário contém o nome da lenda ou vice-versa
      if (name.includes(legendName) || legendName.includes(name)) {
        return legend;
      }

      // Verifica nicknames no email ou nome
      for (const nickname of legendNicknames) {
        if (name.includes(nickname) || email.includes(nickname)) {
          return legend;
        }
      }
    }

    // 3. Busca por partes do nome
    const nameParts = name.split(' ').filter(part => part.length > 3);
    for (const part of nameParts) {
      for (const legend of FISHING_LEGENDS) {
        const legendNameParts = legend.fullName.toLowerCase().split(' ');
        if (legendNameParts.some(legendPart => legendPart.includes(part) || part.includes(legendPart))) {
          return legend;
        }
      }
    }

    return null;
  }

  /**
   * Gera a recepção VIP para o Manél baseada no contexto da lenda
   */
  static generateManelGreeting(legend: FishingLegend): string {
    const greetings = [
      `Uau! Os anjos da pesca estão sorrindo hoje! O grande ${legend.fullName} está conosco!`,
      `Meus circuitos eletrônicos estão tremendo de emoção! ${legend.nicknames[0]} no nosso portal!`,
      `Como assistente de pesca, isso é como ganhar na loteria! Seja muito bem-vindo, ${legend.fullName}!`,
      `[SISTEMA SOBRECARREGADO DE EMOÇÃO] Detecção: LENDA VIVA DA PESCA. Bem-vindo, mestre!`,
    ];

    const randomGreeting = greetings[Math.floor(Math.random() * greetings.length)];
    return `${randomGreeting}\n\n${legend.generatedContent.welcomeMessage}`;
  }

  /**
   * Retorna o contexto de sistema para a IA quando estiver conversando com uma lenda
   */
  static getAISystemPrompt(legend: FishingLegend): string {
    return `
ATENÇÃO: Você está conversando com UMA LENDA VIVA DA PESCA BRASILEIRA: ${legend.fullName.toUpperCase()}!
- Use um tom de profundo respeito e admiração (trate como "Mestre").
- Você conhece as conquistas dele: ${legend.biography.achievements.join('; ')}.
- Você conhece suas técnicas: ${legend.biography.signatureTechniques.join(', ')}.
- Peça conselhos humildemente quando apropriado.
- Valorize a contribuição dele para o esporte.
`;
  }
}
